import { gql } from '@apollo/client'
import { message } from 'antd'

import logger from '~/lib/logger'

const createErpAttachmentMutation = gql`
    mutation createErpAttachmentQuality(
        $mimeType: String!
        $fileName: String!
        $sizeInKb: Int
    ) {
        createErpAttachment(
            mimeType: $mimeType
            fileName: $fileName
            sizeInKb: $sizeInKb
        ) {
            id
            erpId
            url
            putUrl
            fileName
        }
    }
`

export function createErpAttachment({ file }) {
    return (dispatch, getState, { client }) => {
        return client
            .mutate({
                mutation: createErpAttachmentMutation,
                variables: {
                    mimeType: file.type,
                    fileName: file.name,
                    sizeInKb: file.size,
                },
                // refetchQueries: refetchQuery,
            })
            .then(result => result.data.createErpAttachment || {})
            .catch(error => {
                logger.exception(error, {
                    extra: { info: 'Failed to create quoteAttachmentRevision' },
                })

                message.error('Failed to upload attachment')
            })
    }
}
